// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .custom-table-header{
  background-color: #172639!important;
} */

/* Container */
.other-container {
  display: block;
  margin: auto;
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  border-radius: 10px;
  background-color: #172639;
  color: #ff9800;;
  box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.5);
}

.table-container {
  display: block;
  margin: auto;
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  border-radius: 10px;
  box-shadow: 0px 5px 20px #172639;
}

/* Title */
.table-title {
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
}

/* Table Wrapper */
.table-wrapper {
  overflow-x: auto;
}

/* Table */
.responsive-table {
  width: 100%;
  border-collapse: collapse;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.4);
}

.responsive-table thead {
  background-color: #172639!important;
  color: #fff !important;
  cursor: pointer;
}
.responsive-table th {
color:#fff;
}

.responsive-table th,
.responsive-table td {
  padding: 12px 15px;
  text-align: left;
  border-bottom: 1px solid #ddd; 
  white-space: nowrap;
}

.responsive-table tbody tr:hover {
  background-color: rgb(225, 225, 225);
  cursor: pointer;
}

/* Responsive Styles */
@media (max-width: 768px) {
  .table-container {
    width: 100%;
  }
}



.FormContainer {
  background-color: rgba(0, 0, 0, 0.05); /* Black background with 0.5 opacity */
  padding: 20px; /* Add some padding for spacing */
  border-radius: 10px; /* Rounded corners */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Subtle shadow for depth */
  height: 100%;
  width: 100%;
}



.progress-bar-container {
  width: 100%;
  background-color: #e0e0e0;
  border-radius: 10px;
  margin-top: 20px;
  overflow: hidden;
}

.progress-bar {
  height: 20px;
  background-color: #4caf50;
  transition: width 0.5s ease;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-weight: bold;
}



.custBtn {
  /* background-color: #1abc9c; */
  background-color: #172639;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: background-color 0.3s, box-shadow 0.3s;
  font-size: 12px;
}

.custBtn:hover {
  background-color: #16a085;
  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.2);
}

.disabledBtn {
  background-color: gray;
  cursor: not-allowed;
  color: white; /* Optional: Change text color for better readability */
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: background-color 0.3s, box-shadow 0.3s;
}

.FormContainer .custom_input {
  background-color: #fff;
  border: 2px solid #ccc;
  color: #333;
  padding: 5px;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.FormContainer .custom_input:focus {
  border-color: #0d6efd; /* Blue border on focus */
  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5); /* Blue shadow on focus */
  outline: none;
}

.table-container .table {
  width: 100%;
}

.custom_button {
  display: inline-block;
  padding: 7px 30px;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  text-decoration: none;
  /* color: var(--primary-color ); */
  color: black;
  background-color: var(--primary-color);
  border: none;
  border-radius: 5px;
  box-shadow: 7px 7px 7px -1px rgba(10, 100, 169, 0.363), -7px -7px 7px -1px rgba(255, 255, 255, 0.7);
  transition: background-color 0.3s, box-shadow 0.3s, transform 0.3s;
  cursor: pointer;
}

/* Hover Effect */
.custom_button:hover {
  box-shadow: 7px 7px 7px -1px rgba(10, 100, 169, 0.363), -7px -7px 7px -1px rgba(255, 255, 255, 0.7);
  transform: translateY(-2px);
  font-weight: bold;
}

/* Active Effect */
.custom_button:active {
  background-color: #172639;
  box-shadow: 7px 7px 7px -1px rgba(10, 100, 169, 0.363), -7px -7px 7px -1px rgba(255, 255, 255, 0.7);
  transform: translateY(0);
}

/* Disabled State */
.custom_button:disabled {
  background-color: #4d5d6a;
  color: #b3b3b3;
  cursor: not-allowed;
  box-shadow: none;
}


/* progress bar */
.progress-container {
  text-align: center;
  margin-top: 20px;
}

.progress-text {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
}

.progress-bar-background {
  width: 80%;
  height: 30px;
  background-color: #e0e0e0;
  border-radius: 15px;
  overflow: hidden;
  margin: 10px auto;
  position: relative;
}

.progress-bar {
  height: 100%;
  background-color: #1abc9c; /* Beautiful green color */
  transition: width 0.1s ease-in-out; /* Shorter transition duration for smoother effect */
  border-radius: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-weight: bold;
  position: absolute;
  top: 0;
  left: 0;
}


.row1 {
  margin: 20px;
}

.row {
  /* padding: 0 15px; */
}

.custom_input {
  width: 100%;
  padding: 8px;
}

.custom_button {
  padding: 8px 20px;
  margin-top: 10px;
}

.customIcon{
font-size: 50px;
/* padding-top: 10px; */
color: #16a085;
}

/* .table-container {
  width: 100%;
  display: flex;
  justify-content: center;
} */

/* .custom_button {
  font-size: 15px;
  font-weight: 500;
  padding: 10px 25px;
  margin: 0px;
  background-color: #172639;
  color: #ffc107;
  cursor: pointer;
  border: none;
  border-radius: 10px;
  box-shadow: 7px 7px 7px -1px rgba(10, 100, 169, 0.363),
    -7px -7px 7px -1px rgba(255, 255, 255, 0.7);
} */

.custom_button1 {
  font-size: 15px;
  font-weight: 500;
  padding: 10px 25px;
  margin: 0px 20px;
  background-color: #5bc0de;
  color: #172639;
  cursor: pointer;
  border: none;
  border-radius: 10px;
  box-shadow: 7px 7px 7px -1px rgba(82, 171, 240, 0.363), -7px -7px 7px -1px rgba(255, 255, 255, 0.7);
}

.custom_button2 {
  font-size: 15px;
  font-weight: 500;
  padding: 10px 25px;
  margin: 0px 20px;
  background-color: #4caf50;
  color: #ffffff;
  cursor: pointer;
  border: none;
  border-radius: 10px;
  box-shadow: 7px 7px 7px -1px rgba(82, 171, 240, 0.363), -7px -7px 7px -1px rgba(255, 255, 255, 0.7);
}

.custom_button3 {
  font-size: 15px;
  font-weight: 500;
  padding: 10px 25px;
  margin: 0px 20px;
  background-color: #f44336;
  color: #ffffff;
  cursor: pointer;
  border: none;
  border-radius: 10px;
  box-shadow: 7px 7px 7px -1px rgba(82, 171, 240, 0.363), -7px -7px 7px -1px rgba(255, 255, 255, 0.7);
}

.custom_button4 {
  font-size: 15px;
  font-weight: 500;
  padding: 10px 25px;
  margin: 0px 20px;
  background-color: #ff9800;
  color: #ffffff;
  cursor: pointer;
  border: none;
  border-radius: 10px;
  box-shadow: 7px 7px 7px -1px rgba(82, 171, 240, 0.363), -7px -7px 7px -1px rgba(255, 255, 255, 0.7);
}

.custom_button5 {
  font-size: 15px;
  font-weight: 500;
  padding: 10px 25px;
  margin: 0px 20px;
  background-color: #00bcd4;
  color: #ffffff;
  cursor: pointer;
  border: none;
  border-radius: 10px;
  box-shadow: 7px 7px 7px -1px rgba(82, 171, 240, 0.363), -7px -7px 7px -1px rgba(255, 255, 255, 0.7);
}

.custom_button6 {
  font-size: 15px;
  font-weight: 500;
  padding: 10px 25px;
  margin: 0px 20px;
  background-color: #dfdede;
  color: #172639;
  cursor: pointer;
  border: none;
  border-radius: 10px;
  box-shadow: 10px 10px 10px -2px rgba(82, 171, 240, 0.363), -10px -10px 10px -2px rgba(255, 255, 255, 0.7);
}

.custom_button7 {
  font-size: 15px;
  font-weight: 500;
  padding: 10px 25px;
  margin: 0px 20px;
  background-color: #333333;
  color: #ffffff;
  cursor: pointer;
  border: none;
  border-radius: 10px;
  box-shadow: 7px 7px 7px -1px rgba(82, 171, 240, 0.363), -7px -7px 7px -1px rgba(255, 255, 255, 0.7);
}

.glass-button-primary {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.1));
  border: 1px solid rgba(255, 255, 255, 0.4);
  color: black;
  padding: 10px 20px;
  font-size: 16px;
  border-radius: 10px;
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: background 0.3s ease, border 0.3s ease;
  cursor: pointer;
}

.glass-button-primary:hover {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.3));
  border: 1px solid rgba(255, 255, 255, 0.7);
}

.glass-button-primary:active {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.5));
  border: 1px solid rgba(255, 255, 255, 0.9);
}

.custom_input {
  box-shadow: 7px 7px 7px -1px lightgray;
}

.custom_anchor {
  /* text-decoration: none; */
  color: green;
  font-weight: bold;
}

.button-container {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

/* .glass-button {
  background: rgba(255, 255, 255, 0.1); 
  border: 2px solid rgba(255, 255, 255, 0.3); 
  color: blue;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: bold;
  border-radius: 12px;
  backdrop-filter: blur(8px); 
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
  cursor: pointer;
  text-transform: uppercase;
  position: relative;
  overflow: hidden;
} */

.glass-button:hover {
  /* background: rgba(255, 255, 255, 0.2);  */
  /* Lighten background on hover */
  /* border-color: rgba(255, 255, 255, 0.5);  */
  /* Darken border on hover */
  /* box-shadow: 0 6px 12px rgba(0, 0, 0, 0.4);  */
  /* Enhance shadow on hover */
}

.glass-button.red {
  background-color: rgba(253, 10, 10, 0.8); /* Semi-transparent red */
}

.glass-button.green {
  background-color: rgba(76, 175, 80, 0.6); /* Semi-transparent green */
}

.glass-button.blue {
  background-color: rgba(33, 150, 243, 0.6); /* Semi-transparent blue */
}

.glass-button.yellow {
  background-color: rgba(255, 235, 59, 0.6); /* Semi-transparent yellow */
}

.glass-button.purple {
  background-color: rgba(156, 39, 176, 0.6); /* Semi-transparent purple */
}

.glass-button.orange {
  background-color: rgba(255, 152, 0, 0.6); /* Semi-transparent orange */
}

.glass-button.cyan {
  background-color: rgba(0, 188, 212, 0.6); /* Semi-transparent cyan */
}

/* Morph Effects */

.button-container1 {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 20px;
}

.morph-button {
  background: #fff;
  border: 2px solid transparent;
  color: #333;
  padding: 10px 20px;
  font-size: 16px;
  border-radius: 12px;
  transition: background 0.4s ease, color 0.4s ease, transform 0.4s ease, border 0.4s ease;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.morph-button::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: currentColor;
  transition: transform 0.4s ease;
  transform: scale(0);
  z-index: 0;
}

.morph-button:hover::before {
  transform: scale(1);
}

.morph-button:hover {
  color: #fff;
  border-color: currentColor;
  transform: scale(1.05);
}

.morph-button.red {
  color: #ff4c4c;
}

.morph-button.green {
  color: #4caf50;
}

.morph-button.blue {
  color: #2196f3;
}

.morph-button.yellow {
  color: #ffeb3b;
}

.morph-button.purple {
  color: #9c27b0;
}

.morph-button.orange {
  color: #ff9800;
}

.morph-button.cyan {
  color: #00bcd4;
}

/* glass and morph effects */

.button-container2 {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.glass-morph-button {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: #fff;
  padding: 12px 24px;
  font-size: 16px;
  border-radius: 12px;
  backdrop-filter: blur(8px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  transition: background 0.4s ease, color 0.4s ease, transform 0.4s ease, border 0.4s ease;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.glass-morph-button::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: currentColor;
  transition: transform 0.4s ease, background 0.4s ease;
  transform: scale(0);
  z-index: 0;
}

/* .glass-morph-button:hover::before {
  transform: scale(1);
} */

.glass-morph-button:hover {
  color: #fff;
  border-color: transparent;
  transform: scale(1.1);
}

.glass-morph-button.red {
  background-color: #ff4c4c;
  color: #ffffff;
}

.glass-morph-button.green {
  color: #4caf50;
}

.glass-morph-button.blue {
  color: #2196f3;
}

.glass-morph-button.yellow {
  color: #ffeb3b;
}

.glass-morph-button.purple {
  color: #9c27b0;
}

.glass-morph-button.orange {
  color: #ff9800;
}

.glass-morph-button.cyan {
  color: #00bcd4;
}

.button-container3 {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  margin-top: 20px;
}

.glass-button {
  border: none;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: bold;
  border-radius: 12px;
  backdrop-filter: blur(8px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
  cursor: pointer;
  text-transform: uppercase;
  position: relative;
  overflow: hidden;
  color: black;
}

/* /* .glass-button:hover {
    opacity: 0.8;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.4); 
  } */

.glass-button.navy:hover {
  background: rgba(0, 34, 102, 0.6); /* Semi-transparent navy */
  opacity: 0.8;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.4); /* Enhance shadow on hover */
}
.glass-button.navy {
  background: rgba(0, 34, 102, 0.6); /* Semi-transparent navy */
}

.glass-button.teal {
  background: rgba(0, 128, 128, 0.6); /* Semi-transparent teal */
}

.glass-button.maroon {
  background: rgba(128, 0, 0, 0.6); /* Semi-transparent maroon */
}

.glass-button.olive {
  background: rgba(85, 107, 47, 0.6); /* Semi-transparent olive */
}

.glass-button.charcoal {
  background: rgba(54, 69, 79, 0.6); /* Semi-transparent charcoal */
}

.glass-button.purple {
  background: rgba(75, 0, 130, 0.6); /* Semi-transparent purple */
}

.glass-button.slate {
  background: rgba(112, 128, 144, 0.6); /* Semi-transparent slate */
}

.button-container1 {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.glass-button1 {
  border: none;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: bold;
  border-radius: 12px;
  backdrop-filter: blur(8px); /* Frosted glass effect */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
  cursor: pointer;
  text-transform: uppercase;
  position: relative;
  overflow: hidden;
  color: #fff; /* Text color */
}

.glass-button1::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.3);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.glass-button1:hover::before {
  opacity: 1;
}

.glass-button1.primary {
  background: linear-gradient(135deg, rgba(23, 38, 57, 0.8), rgba(23, 38, 57, 0.6));
}

.glass-button1.secondary {
  background: linear-gradient(135deg, rgba(234, 166, 55, 0.8), rgba(234, 166, 55, 0.6));
}

.glass-button1.accent-1 {
  background: linear-gradient(135deg, rgba(23, 38, 57, 0.8), rgba(234, 166, 55, 0.6));
}

.glass-button1.accent-2 {
  background: linear-gradient(135deg, rgba(234, 166, 55, 0.8), rgba(23, 38, 57, 0.6));
}

.glass-button1.accent-3 {
  background: linear-gradient(135deg, rgba(23, 38, 57, 0.8), rgba(234, 166, 55, 0.4));
}

.glass-button1.accent-4 {
  background: linear-gradient(135deg, rgba(234, 166, 55, 0.8), rgba(23, 38, 57, 0.4));
}

.glass-button1.accent-5 {
  background: linear-gradient(135deg, rgba(23, 38, 57, 0.8), rgba(234, 166, 55, 0.8));
}

/* for crud combination */

.button-container_crud {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  margin: 30px 20px;
}

.glass-button_crud {
  border: none;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: bold;
  border-radius: 12px;
  backdrop-filter: blur(5px); /* Frosted glass effect */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
  cursor: pointer;
  text-transform: uppercase;
  position: relative;
  overflow: hidden;
  color: #fff; /* Text color */
}

.glass-button_crud::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.3);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.glass-button_crud:hover::before {
  opacity: 1;
}

.glass-button_crud.create {
  background-color: #eaa637; /* Gold */
}

.glass-button_crud.create:hover {
  background-color: #d68910; /* Medium Amber */
}

.glass-button_crud.read {
  background-color: #3498db; /* Light Blue */
}

.glass-button_crud.read:hover {
  background-color: #2874a6; /* Medium Blue */
}

.glass-button_crud.update {
  background-color: #172639; /* Dark Blue */
}

.glass-button_crud.update:hover {
  background-color: #1b4f72; /* Dark Teal */
}

.glass-button_crud.delete {
  background-color: #c70039; /* Crimson */
}

.glass-button_crud.delete:hover {
  background-color: #a93226; /* Dark Crimson */
}

/* prfessional look */

.button-container {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  margin: 30px 0;
}

.button {
  border: none;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: bold;
  border-radius: 8px;
  transition: background-color 0.3s ease, color 0.3s ease;
  cursor: pointer;
  text-transform: uppercase;
}

.button.primary {
  background-color: #172639;
  color: #fff;
}

.button.primary:hover {
  background-color: #1b4f72;
}

.button.secondary {
  background-color: #eaa637;
  color: #fff;
}

.button.secondary:hover {
  background-color: #d68910;
}

.button.outlined {
  background-color: transparent;
  border: 2px solid #172639;
  color: #172639;
}

.button.outlined:hover {
  background-color: #172639;
  color: #fff;
}

.button.ghost {
  background-color: transparent;
  border: 1px solid #eaa637;
  color: #eaa637;
}

.button.ghost:hover {
  background-color: #eaa637;
  color: #fff;
}

/* From Reference Draft */

.cust_label {
  visibility: hidden;
  width: 100%;
}

/* for modal on the refrence draft */
.modalIcon {
  cursor: pointer;
}
.clip-path {
  /* clip-path: polygon(90% 0%, 100% 50%, 90% 100%, 0% 100%, 5% 50%, 0% 0%);
  background-color: var(--primary-color);
  color: white; */
}
`, "",{"version":3,"sources":["webpack://./src/pages/UploadExcel.css"],"names":[],"mappings":"AAAA;;GAEG;;AAEH,cAAc;AACd;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA,UAAU;AACV;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,mCAAmC;EACnC,sBAAsB;EACtB,eAAe;AACjB;AACA;AACA,UAAU;AACV;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE;IACE,WAAW;EACb;AACF;;;;AAIA;EACE,qCAAqC,EAAE,sCAAsC;EAC7E,aAAa,EAAE,iCAAiC;EAChD,mBAAmB,EAAE,oBAAoB;EACzC,wCAAwC,EAAE,4BAA4B;EACtE,YAAY;EACZ,WAAW;AACb;;;;AAIA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,2BAA2B;EAC3B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;;;AAIA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,kDAAkD;EAClD,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,YAAY,EAAE,uDAAuD;EACrE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,kDAAkD;AACpD;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB,EAAE,yBAAyB;EAChD,0CAA0C,EAAE,yBAAyB;EACrE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,kCAAkC;EAClC,YAAY;EACZ,sCAAsC;EACtC,YAAY;EACZ,kBAAkB;EAClB,mGAAmG;EACnG,kEAAkE;EAClE,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,mGAAmG;EACnG,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,mGAAmG;EACnG,wBAAwB;AAC1B;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;;AAGA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,yBAAyB,EAAE,0BAA0B;EACrD,kCAAkC,EAAE,oDAAoD;EACxF,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;;AAGA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;AACA,eAAe;AACf,uBAAuB;AACvB,cAAc;AACd;;AAEA;;;;GAIG;;AAEH;;;;;;;;;;;;GAYG;;AAEH;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,mGAAmG;AACrG;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,mGAAmG;AACrG;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,mGAAmG;AACrG;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,mGAAmG;AACrG;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,mGAAmG;AACrG;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,yGAAyG;AAC3G;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,mGAAmG;AACrG;;AAEA;EACE,uFAAuF;EACvF,0CAA0C;EAC1C,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,2BAA2B;EAC3B,wCAAwC;EACxC,kDAAkD;EAClD,eAAe;AACjB;;AAEA;EACE,uFAAuF;EACvF,0CAA0C;AAC5C;;AAEA;EACE,uFAAuF;EACvF,0CAA0C;AAC5C;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;;;;;;;;;;;;;;;GAeG;;AAEH;EACE,2CAA2C;EAC3C,gCAAgC;EAChC,6CAA6C;EAC7C,2BAA2B;EAC3B,gDAAgD;EAChD,4BAA4B;AAC9B;;AAEA;EACE,wCAAwC,EAAE,yBAAyB;AACrE;;AAEA;EACE,wCAAwC,EAAE,2BAA2B;AACvE;;AAEA;EACE,yCAAyC,EAAE,0BAA0B;AACvE;;AAEA;EACE,yCAAyC,EAAE,4BAA4B;AACzE;;AAEA;EACE,yCAAyC,EAAE,4BAA4B;AACzE;;AAEA;EACE,wCAAwC,EAAE,4BAA4B;AACxE;;AAEA;EACE,wCAAwC,EAAE,0BAA0B;AACtE;;AAEA,kBAAkB;;AAElB;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,wFAAwF;EACxF,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,+BAA+B;EAC/B,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,4BAA4B;;AAE5B;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,0BAA0B;EAC1B,wCAAwC;EACxC,wFAAwF;EACxF,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,qDAAqD;EACrD,mBAAmB;EACnB,UAAU;AACZ;;AAEA;;GAEG;;AAEH;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;EAC1B,wCAAwC;EACxC,yBAAyB;EACzB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;;;KAGK;;AAEL;EACE,iCAAiC,EAAE,0BAA0B;EAC7D,YAAY;EACZ,yCAAyC,EAAE,4BAA4B;AACzE;AACA;EACE,iCAAiC,EAAE,0BAA0B;AAC/D;;AAEA;EACE,kCAAkC,EAAE,0BAA0B;AAChE;;AAEA;EACE,gCAAgC,EAAE,4BAA4B;AAChE;;AAEA;EACE,kCAAkC,EAAE,2BAA2B;AACjE;;AAEA;EACE,iCAAiC,EAAE,8BAA8B;AACnE;;AAEA;EACE,iCAAiC,EAAE,4BAA4B;AACjE;;AAEA;EACE,oCAAoC,EAAE,2BAA2B;AACnE;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B,EAAE,yBAAyB;EACrD,wCAAwC;EACxC,yBAAyB;EACzB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW,EAAE,eAAe;AAC9B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iFAAiF;AACnF;;AAEA;EACE,qFAAqF;AACvF;;AAEA;EACE,mFAAmF;AACrF;;AAEA;EACE,mFAAmF;AACrF;;AAEA;EACE,mFAAmF;AACrF;;AAEA;EACE,mFAAmF;AACrF;;AAEA;EACE,mFAAmF;AACrF;;AAEA,yBAAyB;;AAEzB;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B,EAAE,yBAAyB;EACrD,wCAAwC;EACxC,yBAAyB;EACzB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW,EAAE,eAAe;AAC9B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB,EAAE,SAAS;AACtC;;AAEA;EACE,yBAAyB,EAAE,iBAAiB;AAC9C;;AAEA;EACE,yBAAyB,EAAE,eAAe;AAC5C;;AAEA;EACE,yBAAyB,EAAE,gBAAgB;AAC7C;;AAEA;EACE,yBAAyB,EAAE,cAAc;AAC3C;;AAEA;EACE,yBAAyB,EAAE,cAAc;AAC3C;;AAEA;EACE,yBAAyB,EAAE,YAAY;AACzC;;AAEA;EACE,yBAAyB,EAAE,iBAAiB;AAC9C;;AAEA,qBAAqB;;AAErB;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,uDAAuD;EACvD,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA,yBAAyB;;AAEzB;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA,oCAAoC;AACpC;EACE,eAAe;AACjB;AACA;EACE;;iBAEe;AACjB","sourcesContent":["/* .custom-table-header{\n  background-color: #172639!important;\n} */\n\n/* Container */\n.other-container {\n  display: block;\n  margin: auto;\n  width: 100%;\n  padding: 20px;\n  box-sizing: border-box;\n  border-radius: 10px;\n  background-color: #172639;\n  color: #ff9800;;\n  box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.5);\n}\n\n.table-container {\n  display: block;\n  margin: auto;\n  width: 100%;\n  padding: 20px;\n  box-sizing: border-box;\n  border-radius: 10px;\n  box-shadow: 0px 5px 20px #172639;\n}\n\n/* Title */\n.table-title {\n  text-align: center;\n  font-size: 24px;\n  font-weight: bold;\n  margin-bottom: 20px;\n}\n\n/* Table Wrapper */\n.table-wrapper {\n  overflow-x: auto;\n}\n\n/* Table */\n.responsive-table {\n  width: 100%;\n  border-collapse: collapse;\n  background-color: #fff;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.4);\n}\n\n.responsive-table thead {\n  background-color: #172639!important;\n  color: #fff !important;\n  cursor: pointer;\n}\n.responsive-table th {\ncolor:#fff;\n}\n\n.responsive-table th,\n.responsive-table td {\n  padding: 12px 15px;\n  text-align: left;\n  border-bottom: 1px solid #ddd; \n  white-space: nowrap;\n}\n\n.responsive-table tbody tr:hover {\n  background-color: rgb(225, 225, 225);\n  cursor: pointer;\n}\n\n/* Responsive Styles */\n@media (max-width: 768px) {\n  .table-container {\n    width: 100%;\n  }\n}\n\n\n\n.FormContainer {\n  background-color: rgba(0, 0, 0, 0.05); /* Black background with 0.5 opacity */\n  padding: 20px; /* Add some padding for spacing */\n  border-radius: 10px; /* Rounded corners */\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Subtle shadow for depth */\n  height: 100%;\n  width: 100%;\n}\n\n\n\n.progress-bar-container {\n  width: 100%;\n  background-color: #e0e0e0;\n  border-radius: 10px;\n  margin-top: 20px;\n  overflow: hidden;\n}\n\n.progress-bar {\n  height: 20px;\n  background-color: #4caf50;\n  transition: width 0.5s ease;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: white;\n  font-weight: bold;\n}\n\n\n\n.custBtn {\n  /* background-color: #1abc9c; */\n  background-color: #172639;\n  color: white;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 5px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  transition: background-color 0.3s, box-shadow 0.3s;\n  font-size: 12px;\n}\n\n.custBtn:hover {\n  background-color: #16a085;\n  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.2);\n}\n\n.disabledBtn {\n  background-color: gray;\n  cursor: not-allowed;\n  color: white; /* Optional: Change text color for better readability */\n  padding: 10px 20px;\n  border: none;\n  border-radius: 5px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  transition: background-color 0.3s, box-shadow 0.3s;\n}\n\n.FormContainer .custom_input {\n  background-color: #fff;\n  border: 2px solid #ccc;\n  color: #333;\n  padding: 5px;\n  border-radius: 8px;\n  transition: all 0.3s ease;\n}\n\n.FormContainer .custom_input:focus {\n  border-color: #0d6efd; /* Blue border on focus */\n  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5); /* Blue shadow on focus */\n  outline: none;\n}\n\n.table-container .table {\n  width: 100%;\n}\n\n.custom_button {\n  display: inline-block;\n  padding: 7px 30px;\n  font-size: 16px;\n  font-weight: 500;\n  text-align: center;\n  text-decoration: none;\n  /* color: var(--primary-color ); */\n  color: black;\n  background-color: var(--primary-color);\n  border: none;\n  border-radius: 5px;\n  box-shadow: 7px 7px 7px -1px rgba(10, 100, 169, 0.363), -7px -7px 7px -1px rgba(255, 255, 255, 0.7);\n  transition: background-color 0.3s, box-shadow 0.3s, transform 0.3s;\n  cursor: pointer;\n}\n\n/* Hover Effect */\n.custom_button:hover {\n  box-shadow: 7px 7px 7px -1px rgba(10, 100, 169, 0.363), -7px -7px 7px -1px rgba(255, 255, 255, 0.7);\n  transform: translateY(-2px);\n  font-weight: bold;\n}\n\n/* Active Effect */\n.custom_button:active {\n  background-color: #172639;\n  box-shadow: 7px 7px 7px -1px rgba(10, 100, 169, 0.363), -7px -7px 7px -1px rgba(255, 255, 255, 0.7);\n  transform: translateY(0);\n}\n\n/* Disabled State */\n.custom_button:disabled {\n  background-color: #4d5d6a;\n  color: #b3b3b3;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n\n/* progress bar */\n.progress-container {\n  text-align: center;\n  margin-top: 20px;\n}\n\n.progress-text {\n  font-size: 16px;\n  font-weight: 600;\n  margin-bottom: 10px;\n}\n\n.progress-bar-background {\n  width: 80%;\n  height: 30px;\n  background-color: #e0e0e0;\n  border-radius: 15px;\n  overflow: hidden;\n  margin: 10px auto;\n  position: relative;\n}\n\n.progress-bar {\n  height: 100%;\n  background-color: #1abc9c; /* Beautiful green color */\n  transition: width 0.1s ease-in-out; /* Shorter transition duration for smoother effect */\n  border-radius: 15px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #fff;\n  font-weight: bold;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n\n.row1 {\n  margin: 20px;\n}\n\n.row {\n  /* padding: 0 15px; */\n}\n\n.custom_input {\n  width: 100%;\n  padding: 8px;\n}\n\n.custom_button {\n  padding: 8px 20px;\n  margin-top: 10px;\n}\n\n.customIcon{\nfont-size: 50px;\n/* padding-top: 10px; */\ncolor: #16a085;\n}\n\n/* .table-container {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n} */\n\n/* .custom_button {\n  font-size: 15px;\n  font-weight: 500;\n  padding: 10px 25px;\n  margin: 0px;\n  background-color: #172639;\n  color: #ffc107;\n  cursor: pointer;\n  border: none;\n  border-radius: 10px;\n  box-shadow: 7px 7px 7px -1px rgba(10, 100, 169, 0.363),\n    -7px -7px 7px -1px rgba(255, 255, 255, 0.7);\n} */\n\n.custom_button1 {\n  font-size: 15px;\n  font-weight: 500;\n  padding: 10px 25px;\n  margin: 0px 20px;\n  background-color: #5bc0de;\n  color: #172639;\n  cursor: pointer;\n  border: none;\n  border-radius: 10px;\n  box-shadow: 7px 7px 7px -1px rgba(82, 171, 240, 0.363), -7px -7px 7px -1px rgba(255, 255, 255, 0.7);\n}\n\n.custom_button2 {\n  font-size: 15px;\n  font-weight: 500;\n  padding: 10px 25px;\n  margin: 0px 20px;\n  background-color: #4caf50;\n  color: #ffffff;\n  cursor: pointer;\n  border: none;\n  border-radius: 10px;\n  box-shadow: 7px 7px 7px -1px rgba(82, 171, 240, 0.363), -7px -7px 7px -1px rgba(255, 255, 255, 0.7);\n}\n\n.custom_button3 {\n  font-size: 15px;\n  font-weight: 500;\n  padding: 10px 25px;\n  margin: 0px 20px;\n  background-color: #f44336;\n  color: #ffffff;\n  cursor: pointer;\n  border: none;\n  border-radius: 10px;\n  box-shadow: 7px 7px 7px -1px rgba(82, 171, 240, 0.363), -7px -7px 7px -1px rgba(255, 255, 255, 0.7);\n}\n\n.custom_button4 {\n  font-size: 15px;\n  font-weight: 500;\n  padding: 10px 25px;\n  margin: 0px 20px;\n  background-color: #ff9800;\n  color: #ffffff;\n  cursor: pointer;\n  border: none;\n  border-radius: 10px;\n  box-shadow: 7px 7px 7px -1px rgba(82, 171, 240, 0.363), -7px -7px 7px -1px rgba(255, 255, 255, 0.7);\n}\n\n.custom_button5 {\n  font-size: 15px;\n  font-weight: 500;\n  padding: 10px 25px;\n  margin: 0px 20px;\n  background-color: #00bcd4;\n  color: #ffffff;\n  cursor: pointer;\n  border: none;\n  border-radius: 10px;\n  box-shadow: 7px 7px 7px -1px rgba(82, 171, 240, 0.363), -7px -7px 7px -1px rgba(255, 255, 255, 0.7);\n}\n\n.custom_button6 {\n  font-size: 15px;\n  font-weight: 500;\n  padding: 10px 25px;\n  margin: 0px 20px;\n  background-color: #dfdede;\n  color: #172639;\n  cursor: pointer;\n  border: none;\n  border-radius: 10px;\n  box-shadow: 10px 10px 10px -2px rgba(82, 171, 240, 0.363), -10px -10px 10px -2px rgba(255, 255, 255, 0.7);\n}\n\n.custom_button7 {\n  font-size: 15px;\n  font-weight: 500;\n  padding: 10px 25px;\n  margin: 0px 20px;\n  background-color: #333333;\n  color: #ffffff;\n  cursor: pointer;\n  border: none;\n  border-radius: 10px;\n  box-shadow: 7px 7px 7px -1px rgba(82, 171, 240, 0.363), -7px -7px 7px -1px rgba(255, 255, 255, 0.7);\n}\n\n.glass-button-primary {\n  background: linear-gradient(135deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.1));\n  border: 1px solid rgba(255, 255, 255, 0.4);\n  color: black;\n  padding: 10px 20px;\n  font-size: 16px;\n  border-radius: 10px;\n  backdrop-filter: blur(10px);\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  transition: background 0.3s ease, border 0.3s ease;\n  cursor: pointer;\n}\n\n.glass-button-primary:hover {\n  background: linear-gradient(135deg, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.3));\n  border: 1px solid rgba(255, 255, 255, 0.7);\n}\n\n.glass-button-primary:active {\n  background: linear-gradient(135deg, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.5));\n  border: 1px solid rgba(255, 255, 255, 0.9);\n}\n\n.custom_input {\n  box-shadow: 7px 7px 7px -1px lightgray;\n}\n\n.custom_anchor {\n  /* text-decoration: none; */\n  color: green;\n  font-weight: bold;\n}\n\n.button-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 15px;\n}\n\n/* .glass-button {\n  background: rgba(255, 255, 255, 0.1); \n  border: 2px solid rgba(255, 255, 255, 0.3); \n  color: blue;\n  padding: 12px 24px;\n  font-size: 16px;\n  font-weight: bold;\n  border-radius: 12px;\n  backdrop-filter: blur(8px); \n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);\n  transition: all 0.3s ease;\n  cursor: pointer;\n  text-transform: uppercase;\n  position: relative;\n  overflow: hidden;\n} */\n\n.glass-button:hover {\n  /* background: rgba(255, 255, 255, 0.2);  */\n  /* Lighten background on hover */\n  /* border-color: rgba(255, 255, 255, 0.5);  */\n  /* Darken border on hover */\n  /* box-shadow: 0 6px 12px rgba(0, 0, 0, 0.4);  */\n  /* Enhance shadow on hover */\n}\n\n.glass-button.red {\n  background-color: rgba(253, 10, 10, 0.8); /* Semi-transparent red */\n}\n\n.glass-button.green {\n  background-color: rgba(76, 175, 80, 0.6); /* Semi-transparent green */\n}\n\n.glass-button.blue {\n  background-color: rgba(33, 150, 243, 0.6); /* Semi-transparent blue */\n}\n\n.glass-button.yellow {\n  background-color: rgba(255, 235, 59, 0.6); /* Semi-transparent yellow */\n}\n\n.glass-button.purple {\n  background-color: rgba(156, 39, 176, 0.6); /* Semi-transparent purple */\n}\n\n.glass-button.orange {\n  background-color: rgba(255, 152, 0, 0.6); /* Semi-transparent orange */\n}\n\n.glass-button.cyan {\n  background-color: rgba(0, 188, 212, 0.6); /* Semi-transparent cyan */\n}\n\n/* Morph Effects */\n\n.button-container1 {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n.morph-button {\n  background: #fff;\n  border: 2px solid transparent;\n  color: #333;\n  padding: 10px 20px;\n  font-size: 16px;\n  border-radius: 12px;\n  transition: background 0.4s ease, color 0.4s ease, transform 0.4s ease, border 0.4s ease;\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n}\n\n.morph-button::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: currentColor;\n  transition: transform 0.4s ease;\n  transform: scale(0);\n  z-index: 0;\n}\n\n.morph-button:hover::before {\n  transform: scale(1);\n}\n\n.morph-button:hover {\n  color: #fff;\n  border-color: currentColor;\n  transform: scale(1.05);\n}\n\n.morph-button.red {\n  color: #ff4c4c;\n}\n\n.morph-button.green {\n  color: #4caf50;\n}\n\n.morph-button.blue {\n  color: #2196f3;\n}\n\n.morph-button.yellow {\n  color: #ffeb3b;\n}\n\n.morph-button.purple {\n  color: #9c27b0;\n}\n\n.morph-button.orange {\n  color: #ff9800;\n}\n\n.morph-button.cyan {\n  color: #00bcd4;\n}\n\n/* glass and morph effects */\n\n.button-container2 {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.glass-morph-button {\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  color: #fff;\n  padding: 12px 24px;\n  font-size: 16px;\n  border-radius: 12px;\n  backdrop-filter: blur(8px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  transition: background 0.4s ease, color 0.4s ease, transform 0.4s ease, border 0.4s ease;\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n}\n\n.glass-morph-button::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: currentColor;\n  transition: transform 0.4s ease, background 0.4s ease;\n  transform: scale(0);\n  z-index: 0;\n}\n\n/* .glass-morph-button:hover::before {\n  transform: scale(1);\n} */\n\n.glass-morph-button:hover {\n  color: #fff;\n  border-color: transparent;\n  transform: scale(1.1);\n}\n\n.glass-morph-button.red {\n  background-color: #ff4c4c;\n  color: #ffffff;\n}\n\n.glass-morph-button.green {\n  color: #4caf50;\n}\n\n.glass-morph-button.blue {\n  color: #2196f3;\n}\n\n.glass-morph-button.yellow {\n  color: #ffeb3b;\n}\n\n.glass-morph-button.purple {\n  color: #9c27b0;\n}\n\n.glass-morph-button.orange {\n  color: #ff9800;\n}\n\n.glass-morph-button.cyan {\n  color: #00bcd4;\n}\n\n.button-container3 {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 15px;\n  margin-top: 20px;\n}\n\n.glass-button {\n  border: none;\n  padding: 12px 24px;\n  font-size: 16px;\n  font-weight: bold;\n  border-radius: 12px;\n  backdrop-filter: blur(8px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);\n  transition: all 0.3s ease;\n  cursor: pointer;\n  text-transform: uppercase;\n  position: relative;\n  overflow: hidden;\n  color: black;\n}\n\n/* /* .glass-button:hover {\n    opacity: 0.8;\n    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.4); \n  } */\n\n.glass-button.navy:hover {\n  background: rgba(0, 34, 102, 0.6); /* Semi-transparent navy */\n  opacity: 0.8;\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.4); /* Enhance shadow on hover */\n}\n.glass-button.navy {\n  background: rgba(0, 34, 102, 0.6); /* Semi-transparent navy */\n}\n\n.glass-button.teal {\n  background: rgba(0, 128, 128, 0.6); /* Semi-transparent teal */\n}\n\n.glass-button.maroon {\n  background: rgba(128, 0, 0, 0.6); /* Semi-transparent maroon */\n}\n\n.glass-button.olive {\n  background: rgba(85, 107, 47, 0.6); /* Semi-transparent olive */\n}\n\n.glass-button.charcoal {\n  background: rgba(54, 69, 79, 0.6); /* Semi-transparent charcoal */\n}\n\n.glass-button.purple {\n  background: rgba(75, 0, 130, 0.6); /* Semi-transparent purple */\n}\n\n.glass-button.slate {\n  background: rgba(112, 128, 144, 0.6); /* Semi-transparent slate */\n}\n\n.button-container1 {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 15px;\n}\n\n.glass-button1 {\n  border: none;\n  padding: 12px 24px;\n  font-size: 16px;\n  font-weight: bold;\n  border-radius: 12px;\n  backdrop-filter: blur(8px); /* Frosted glass effect */\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);\n  transition: all 0.3s ease;\n  cursor: pointer;\n  text-transform: uppercase;\n  position: relative;\n  overflow: hidden;\n  color: #fff; /* Text color */\n}\n\n.glass-button1::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(255, 255, 255, 0.3);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.glass-button1:hover::before {\n  opacity: 1;\n}\n\n.glass-button1.primary {\n  background: linear-gradient(135deg, rgba(23, 38, 57, 0.8), rgba(23, 38, 57, 0.6));\n}\n\n.glass-button1.secondary {\n  background: linear-gradient(135deg, rgba(234, 166, 55, 0.8), rgba(234, 166, 55, 0.6));\n}\n\n.glass-button1.accent-1 {\n  background: linear-gradient(135deg, rgba(23, 38, 57, 0.8), rgba(234, 166, 55, 0.6));\n}\n\n.glass-button1.accent-2 {\n  background: linear-gradient(135deg, rgba(234, 166, 55, 0.8), rgba(23, 38, 57, 0.6));\n}\n\n.glass-button1.accent-3 {\n  background: linear-gradient(135deg, rgba(23, 38, 57, 0.8), rgba(234, 166, 55, 0.4));\n}\n\n.glass-button1.accent-4 {\n  background: linear-gradient(135deg, rgba(234, 166, 55, 0.8), rgba(23, 38, 57, 0.4));\n}\n\n.glass-button1.accent-5 {\n  background: linear-gradient(135deg, rgba(23, 38, 57, 0.8), rgba(234, 166, 55, 0.8));\n}\n\n/* for crud combination */\n\n.button-container_crud {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 15px;\n  margin: 30px 20px;\n}\n\n.glass-button_crud {\n  border: none;\n  padding: 12px 24px;\n  font-size: 16px;\n  font-weight: bold;\n  border-radius: 12px;\n  backdrop-filter: blur(5px); /* Frosted glass effect */\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);\n  transition: all 0.3s ease;\n  cursor: pointer;\n  text-transform: uppercase;\n  position: relative;\n  overflow: hidden;\n  color: #fff; /* Text color */\n}\n\n.glass-button_crud::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(255, 255, 255, 0.3);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.glass-button_crud:hover::before {\n  opacity: 1;\n}\n\n.glass-button_crud.create {\n  background-color: #eaa637; /* Gold */\n}\n\n.glass-button_crud.create:hover {\n  background-color: #d68910; /* Medium Amber */\n}\n\n.glass-button_crud.read {\n  background-color: #3498db; /* Light Blue */\n}\n\n.glass-button_crud.read:hover {\n  background-color: #2874a6; /* Medium Blue */\n}\n\n.glass-button_crud.update {\n  background-color: #172639; /* Dark Blue */\n}\n\n.glass-button_crud.update:hover {\n  background-color: #1b4f72; /* Dark Teal */\n}\n\n.glass-button_crud.delete {\n  background-color: #c70039; /* Crimson */\n}\n\n.glass-button_crud.delete:hover {\n  background-color: #a93226; /* Dark Crimson */\n}\n\n/* prfessional look */\n\n.button-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 15px;\n  margin: 30px 0;\n}\n\n.button {\n  border: none;\n  padding: 12px 24px;\n  font-size: 16px;\n  font-weight: bold;\n  border-radius: 8px;\n  transition: background-color 0.3s ease, color 0.3s ease;\n  cursor: pointer;\n  text-transform: uppercase;\n}\n\n.button.primary {\n  background-color: #172639;\n  color: #fff;\n}\n\n.button.primary:hover {\n  background-color: #1b4f72;\n}\n\n.button.secondary {\n  background-color: #eaa637;\n  color: #fff;\n}\n\n.button.secondary:hover {\n  background-color: #d68910;\n}\n\n.button.outlined {\n  background-color: transparent;\n  border: 2px solid #172639;\n  color: #172639;\n}\n\n.button.outlined:hover {\n  background-color: #172639;\n  color: #fff;\n}\n\n.button.ghost {\n  background-color: transparent;\n  border: 1px solid #eaa637;\n  color: #eaa637;\n}\n\n.button.ghost:hover {\n  background-color: #eaa637;\n  color: #fff;\n}\n\n/* From Reference Draft */\n\n.cust_label {\n  visibility: hidden;\n  width: 100%;\n}\n\n/* for modal on the refrence draft */\n.modalIcon {\n  cursor: pointer;\n}\n.clip-path {\n  /* clip-path: polygon(90% 0%, 100% 50%, 90% 100%, 0% 100%, 5% 50%, 0% 0%);\n  background-color: var(--primary-color);\n  color: white; */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
